import styles from "./SideBrands.module.scss";
import classNames from "classnames/bind";
import Brands from "~/Data/Brands";
import { Link, NavLink } from "react-router-dom";
import React from "react";
const cx = classNames.bind(styles);
function SideBrands() {
    console.log("sidaaaaaaaaaaaaaae");
    const mediaQuery = window.matchMedia("(min-width: 768px)").matches;

    return (
        <>
            <div className={cx("list_wrap")}>
                <div className={cx("list")}>
                    <ul>
                        {Brands.map((brand, index) => {
                            return (
                                <li
                                    key={index}
                                    id={brand.brand.toLocaleLowerCase()}
                                >
                                    <NavLink
                                        to={brand.path}
                                        className={(nav) =>
                                            cx("list_item", {
                                                active: nav.isActive,
                                            })
                                        }
                                    >
                                        <h5>{brand.brand}</h5>
                                        <img
                                            src={brand.avatar}
                                            alt={`Logo hãng siêu xe ${brand.brand}`}
                                        />
                                    </NavLink>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {mediaQuery && (
                    <div className={cx("list_alpha")}>
                        <ul>
                            <li>
                                <Link to="/brands/arrinera">A</Link>
                            </li>
                            <li>
                                <Link to="/brands/bugatti">B</Link>
                            </li>

                            <li>
                                <Link to="/brands/ferrari">F</Link>
                            </li>

                            <li>
                                <Link to="/brands/hennessey">H</Link>
                            </li>

                            <li>
                                <Link to="/brands/jaguar">J</Link>
                            </li>
                            <li>
                                <Link to="/brands/koenigsegg">K</Link>
                            </li>
                            <li>
                                <Link to="/brands/lamborghini">L</Link>
                            </li>
                            <li>
                                <Link to="/brands/maserati">M</Link>
                            </li>
                            <li>
                                <Link to="/brands/noble">N</Link>
                            </li>

                            <li>
                                <Link to="/brands/pagani">P</Link>
                            </li>

                            <li>
                                <Link to="/brands/rolls-royce">R</Link>
                            </li>
                            <li>
                                <Link to="/brands/saleen">S</Link>
                            </li>
                            <li>
                                <Link to="/brands/w-motors">W</Link>
                            </li>
                            <li>
                                <Link to="/brands/zenvo">Z</Link>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
}

export default React.memo(SideBrands);
